<div class="n-oldalfej">
  <div>
    <h2>Béren kívüli juttatások listája</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · béren kívüli és egyes meghatározott juttatások, SZÉP-kártya</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
  <label class="ev-valaszto" *ngIf="ful === 'lista'">Hónap
    <select [ngModel]="ho" (ngModelChange)="hoValt(+$event)"><option *ngFor="let h of honapok" [ngValue]="h.value">{{ h.label }}</option></select>
  </label>
  <ion-button (click)="uj(ful === 'szep' ? 'szep_rekreacios' : 'csekely_ajandek')" [disabled]="!aktiv.ugyfelId">
    <ion-icon slot="start" name="add-outline"></ion-icon>{{ ful === 'szep' ? 'SZÉP-utalás' : 'Új juttatás' }}</ion-button>
</div>

<div class="b-fulek">
  <button *ngFor="let f of fulek" type="button" [class.aktiv]="ful === f.k" (click)="fulValt(f.k)">{{ f.c }}</button>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<!-- ═══════════════ LISTA ═══════════════ -->
<ng-container *ngIf="aktiv.ugyfelId && ful === 'lista' && lista">
  <div class="n-szuro-sor">
    <span class="cimke">{{ idoszak }}</span>
    <span class="cimke sarga" *ngIf="kivas">KIVA-alany: szocho helyett KIVA-alap</span>
    <div class="spacer"></div>
    <button type="button" class="ov-gomb" (click)="ujraszamol()" [disabled]="!lista.sorok.length" title="A tételek közterheinek újraszámolása az aktuális paraméterekkel">
      <ion-icon name="refresh-outline"></ion-icon>Újraszámolás</button>
    <button type="button" class="ov-gomb" (click)="nyomtatOsszesito()" [disabled]="!lista.sorok.length"><ion-icon name="print-outline"></ion-icon>Összesítő</button>
    <button type="button" class="ov-gomb" (click)="nyomtatTetelek()" [disabled]="!lista.sorok.length"><ion-icon name="print-outline"></ion-icon>Tételes lista</button>
    <button type="button" class="ov-gomb" (click)="csv()" [disabled]="!lista.sorok.length"><ion-icon name="download-outline"></ion-icon>CSV</button>
    <button type="button" class="ov-gomb" (click)="parameterek()"><ion-icon name="options-outline"></ion-icon>Paraméterek</button>
  </div>

  <div class="ata-kpi">
    <div class="n-panel ata-k"><span>Juttatások értéke</span><b>{{ ft(lista.osszesen.ertek) }} Ft</b><small>{{ lista.osszesen.db }} tétel · {{ idoszak }}</small></div>
    <div class="n-panel ata-k"><span>Adóalap</span><b>{{ ft(lista.osszesen.adoalap) }} Ft</b>
      <small>egyes meghat.: érték × {{ tizedes(param.adoalap_szorzo) }} · béren kívüli: érték</small></div>
    <div class="n-panel ata-k ata-teher"><span>Közteher</span><b>{{ ft(lista.osszesen.szja + lista.osszesen.szocho) }} Ft</b>
      <small>SZJA {{ ft(lista.osszesen.szja) }}<ng-container *ngIf="!kivas"> · szocho {{ ft(lista.osszesen.szocho) }}</ng-container></small></div>
    <div class="n-panel ata-k" *ngIf="kivas"><span>KIVA-alapba kerül</span><b>{{ ft(lista.osszesen.kiva_alap) }} Ft</b><small>személyi jellegű kifizetés</small></div>
  </div>

  <div class="ures" *ngIf="!lista.sorok.length"><ion-icon name="gift-outline"></ion-icon>{{ idoszak }}: nincs rögzített juttatás.</div>

  <ng-container *ngIf="lista.sorok.length">
    <!-- típusonként -->
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr>
          <th>Juttatás</th><th>Kategória</th><th class="num">Tétel</th><th class="num">Érték</th><th class="num">Kereten felül</th>
          <th class="num cs-afa">Adóalap</th><th class="num cs-penz">SZJA</th><th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho' }}</th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let t of lista.tipusonkent">
            <td><b>{{ t.cim }}</b> <span class="halvany">{{ t.forras }}</span></td>
            <td><span class="cimke" [class.zold]="t.kategoria === 'berenkivuli'">{{ kategoriaCim(t.kategoria) }}</span></td>
            <td class="num">{{ t.db }}</td>
            <td class="num">{{ ft(t.ertek) }}</td>
            <td class="num">{{ t.kereten_felul ? ft(t.kereten_felul) : '' }}</td>
            <td class="num cs-afa">{{ ft(t.adoalap) }}</td>
            <td class="num cs-penz">{{ ft(t.szja) }}</td>
            <td class="num cs-penz">{{ ft(kivas ? t.kiva_alap : t.szocho) }}</td>
          </tr>
        </tbody>
        <tfoot><tr>
          <td colspan="2">Összesen</td><td class="num">{{ lista.osszesen.db }}</td><td class="num">{{ ft(lista.osszesen.ertek) }}</td>
          <td class="num">{{ ft(lista.osszesen.kereten_felul) }}</td><td class="num cs-afa">{{ ft(lista.osszesen.adoalap) }}</td>
          <td class="num cs-penz">{{ ft(lista.osszesen.szja) }}</td><td class="num cs-penz">{{ ft(kivas ? lista.osszesen.kiva_alap : lista.osszesen.szocho) }}</td>
        </tr></tfoot>
      </table>
    </div>

    <!-- éves nézetben havonta -->
    <div class="tabla-wrap" *ngIf="!ho && lista.havonta?.length">
      <table class="n-racs">
        <thead><tr>
          <th>Hónap</th><th class="num">Tétel</th><th class="num">Érték</th><th class="num cs-afa">Adóalap</th>
          <th class="num cs-penz">SZJA</th><th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho' }}</th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let h of lista.havonta" [class.jt-halvany]="!h.db">
            <td><b>{{ honapNev(h.ho) }}</b></td><td class="num">{{ h.db || '' }}</td><td class="num">{{ h.db ? ft(h.ertek) : '' }}</td>
            <td class="num cs-afa">{{ h.db ? ft(h.adoalap) : '' }}</td><td class="num cs-penz">{{ h.db ? ft(h.szja) : '' }}</td>
            <td class="num cs-penz">{{ h.db ? ft(kivas ? h.kiva_alap : h.szocho) : '' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- tételesen -->
    <div class="tabla-wrap">
      <table class="n-racs">
        <thead><tr>
          <th>Dátum</th><th>Juttatás</th><th>Munkavállaló</th><th>Megnevezés</th><th class="num">Érték</th><th class="num">Kereten felül</th>
          <th class="num cs-afa">Adóalap</th><th class="num cs-penz">SZJA</th><th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho' }}</th><th></th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let s of lista.sorok" (dblclick)="modosit(s)">
            <td>{{ s.datum }}</td>
            <td>{{ s.tipus_cim }} <span class="cimke zold" *ngIf="s.adomentes">adómentes</span></td>
            <td>{{ s.alkalmazott_nev || '—' }}</td>
            <td><div class="n-ket-sor" [title]="s.megnevezes || ''">{{ s.megnevezes }}</div></td>
            <td class="num">{{ ft(s.ertek) }}</td>
            <td class="num"><span class="cimke sarga" *ngIf="s.kereten_felul">{{ ft(s.kereten_felul) }}</span></td>
            <td class="num cs-afa">{{ ft(s.adoalap) }}</td>
            <td class="num cs-penz">{{ ft(s.szja) }}</td>
            <td class="num cs-penz">{{ ft(kivas ? s.kiva_alap : s.szocho) }}</td>
            <td class="ber-muv">
              <button type="button" class="kv-mini" (click)="modosit(s)" [title]="sajatOldal(s.tipus) ? 'A saját képernyőjén szerkeszthető' : 'Módosítás'">
                <ion-icon [name]="sajatOldal(s.tipus) ? 'open-outline' : 'create-outline'"></ion-icon></button>
              <button type="button" class="kv-torol" *ngIf="!sajatOldal(s.tipus)" (click)="torol(s)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</ng-container>

<!-- ═══════════════ SZÉP-KÁRTYA ═══════════════ -->
<ng-container *ngIf="aktiv.ugyfelId && ful === 'szep' && szep">
  <div class="n-szuro-sor">
    <span class="cimke">Rekreációs keret: {{ ft(szep.keret.rekreacios) }} Ft/év, időarányosan</span>
    <span class="cimke">Aktív Magyarok: {{ ft(szep.keret.aktiv_felev) }} Ft/félév</span>
    <span class="cimke sarga" *ngIf="szepFelul > 0">Kereten felül összesen: {{ ft(szepFelul) }} Ft</span>
    <div class="spacer"></div>
    <button type="button" class="ov-gomb" (click)="nyomtatSzep()" [disabled]="!szep.alkalmazottak.length"><ion-icon name="print-outline"></ion-icon>Nyomtatás</button>
    <button type="button" class="ov-gomb" (click)="parameterek()"><ion-icon name="options-outline"></ion-icon>Paraméterek</button>
  </div>

  <div class="ures" *ngIf="!szep.alkalmazottak.length"><ion-icon name="card-outline"></ion-icon>{{ aktiv.ev }}. évben nincs foglalkoztatott munkavállaló.</div>

  <div class="tabla-wrap" *ngIf="szep.alkalmazottak.length">
    <table class="n-racs">
      <thead>
        <tr>
          <th rowspan="2">Munkavállaló</th><th rowspan="2" class="num" title="Az évben munkaviszonyban töltött napok (a jogviszonyokból)">Napok</th>
          <th colspan="4" class="jt-csoport cs-penz">Rekreációs keret</th>
          <th colspan="3" class="jt-csoport cs-afa">Aktív Magyarok (I. / II. félév)</th>
          <th rowspan="2" class="num">SZJA</th><th rowspan="2" class="num">{{ kivas ? 'Szocho (KIVA)' : 'Szocho' }}</th>
        </tr>
        <tr>
          <th class="num cs-penz">Keret</th><th class="num cs-penz">Utalva</th><th class="num cs-penz">Maradék</th><th class="num cs-penz">Kereten felül</th>
          <th class="num cs-afa">Keret</th><th class="num cs-afa">Utalva</th><th class="num cs-afa">Kereten felül</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of szep.alkalmazottak" [class.jt-halvany]="!a.rekreacios.utalt && !a.aktiv.utalt_1 && !a.aktiv.utalt_2">
          <td><b>{{ a.nev }}</b><span class="halvany" *ngIf="a.becsult" title="Nincs dátumozott jogviszony – teljes évvel számolva"> · teljes év</span></td>
          <td class="num">{{ a.napok }}</td>
          <td class="num cs-penz">{{ ft(a.rekreacios.keret) }}</td>
          <td class="num cs-penz">{{ ft(a.rekreacios.utalt) }}</td>
          <td class="num cs-penz">{{ ft(a.rekreacios.keret - a.rekreacios.utalt > 0 ? a.rekreacios.keret - a.rekreacios.utalt : 0) }}</td>
          <td class="num cs-penz"><span class="cimke sarga" *ngIf="a.rekreacios.kereten_felul">{{ ft(a.rekreacios.kereten_felul) }}</span></td>
          <td class="num cs-afa">{{ ft(a.aktiv.keret_1) }} / {{ ft(a.aktiv.keret_2) }}</td>
          <td class="num cs-afa">{{ ft(a.aktiv.utalt_1) }} / {{ ft(a.aktiv.utalt_2) }}</td>
          <td class="num cs-afa"><span class="cimke sarga" *ngIf="a.aktiv.kereten_felul">{{ ft(a.aktiv.kereten_felul) }}</span></td>
          <td class="num">{{ ft(a.szja) }}</td>
          <td class="num">{{ ft(a.szocho) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="n-panel jt-figy" *ngIf="szepFelul > 0">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <div>
      <b>Kereten felüli SZÉP-juttatás.</b> A keretet meghaladó rész nem béren kívüli, hanem <b>egyes meghatározott juttatásként</b>
      adózik (adóalap × {{ tizedes(param.adoalap_szorzo) }}, SZJA {{ szazalek(param.szja_kulcs) }}%<ng-container *ngIf="!kivas"> + szocho {{ szazalek(param.szocho_kulcs) }}%</ng-container>),
      és a <b>juttatás hónapjának</b> kötelezettségeként kell bevallani és megfizetni (nem negyedévesen) – NAV 49. füzet.
    </div>
  </div>

  <div class="n-panel" *ngIf="szep.utalasok.length">
    <div class="n-panel-cim">Utalások – {{ aktiv.ev }}</div>
    <div class="tabla-wrap jt-belso">
      <table class="n-racs">
        <thead><tr>
          <th>Dátum</th><th>Munkavállaló</th><th>Keret</th><th class="num">Összeg</th><th class="num">Kereten felül</th>
          <th class="num cs-afa">Adóalap</th><th class="num cs-penz">SZJA</th><th class="num cs-penz">{{ kivas ? 'KIVA-alapba' : 'Szocho' }}</th><th>Megjegyzés</th><th></th>
        </tr></thead>
        <tbody>
          <tr *ngFor="let s of szep.utalasok" (dblclick)="modosit(s)">
            <td>{{ s.datum }}</td><td>{{ s.alkalmazott_nev }}</td>
            <td><span class="cimke" [class.petrol]="s.tipus === 'szep_aktiv'">{{ s.tipus === 'szep_aktiv' ? 'Aktív Magyarok' : 'rekreációs' }}</span></td>
            <td class="num">{{ ft(s.ertek) }}</td>
            <td class="num"><span class="cimke sarga" *ngIf="s.kereten_felul">{{ ft(s.kereten_felul) }}</span></td>
            <td class="num cs-afa">{{ ft(s.adoalap) }}</td><td class="num cs-penz">{{ ft(s.szja) }}</td>
            <td class="num cs-penz">{{ ft(kivas ? s.kiva_alap : s.szocho) }}</td>
            <td class="halvany">{{ s.megjegyzes }}</td>
            <td class="ber-muv">
              <button type="button" class="kv-mini" (click)="modosit(s)" title="Módosítás"><ion-icon name="create-outline"></ion-icon></button>
              <button type="button" class="kv-torol" (click)="torol(s)" title="Törlés"><ion-icon name="trash-outline"></ion-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="n-panel ata-info jt-info">
    <div class="n-panel-cim">SZÉP-kártya szabályai</div>
    <ul>
      <li>2023. január 1-jétől a SZÉP-kártyának nincsenek alszámlái (szálláshely / vendéglátás / szabadidő): egy <b>rekreációs keret</b> van,
        évi {{ ft(szep.keret.rekreacios) }} Ft – év közbeni belépésnél/kilépésnél a munkaviszonyban töltött napokkal <b>arányosan</b> (NAV, 2022.12.30.).</li>
      <li>Az <b>„Aktív Magyarok”</b> keret félévente {{ ft(szep.keret.aktiv_felev) }} Ft (évi 120 000 Ft) – <i>ellenőrizendő</i>, a paraméterek között módosítható.</li>
      <li>A kereten belüli utalás béren kívüli juttatás: adóalap = az érték, SZJA {{ szazalek(param.szja_kulcs) }}%<ng-container *ngIf="!kivas"> + szocho {{ szazalek(param.szocho_kulcs) }}%</ng-container>;
        negyedévente, a negyedévet követő hónap 12-éig kell bevallani.</li>
      <li>Az utalásokat dátum szerint soroljuk a keretbe: egy korábbi dátumú utalás rögzítése a későbbiek besorolását is átrendezi.</li>
      <li>A keret munkavállalónként <b>összesen</b> értendő: ha az évben más munkáltatótól is kapott SZÉP-juttatást, azt a program nem látja.</li>
      <li *ngIf="kivas">KIVA-alanynál szocho nincs: a juttatás adóalapja a KIVA alapjába tartozik.</li>
    </ul>
  </div>
</ng-container>

<!-- ═══════════════ rögzítő ablak ═══════════════ -->
<ion-modal #szerkModal cssClass="ber-urlap-modal" (didDismiss)="zarEngedi()">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>{{ szerk?.id ? 'Juttatás módosítása' : (szepE(szerk?.tipus) ? 'SZÉP-utalás rögzítése' : 'Új juttatás') }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szerkModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <app-szerk-zar-sav [zar]="zarSor"></app-szerk-zar-sav>
        <label class="kv-mezo"><span>Juttatás</span>
          <select [(ngModel)]="szerk.tipus"><option *ngFor="let t of szerkesztheto" [ngValue]="t.tipus">{{ t.cim }}</option></select></label>
        <label class="kv-mezo"><span>Munkavállaló{{ szepE(szerk.tipus) ? ' *' : '' }}</span>
          <select [(ngModel)]="szerk.alkalmazott_id">
            <option [ngValue]="null">{{ szepE(szerk.tipus) ? '– válassz –' : '– nincs (nem személyhez kötött) –' }}</option>
            <option *ngFor="let a of alkalmazottak" [ngValue]="a.id">{{ a.nev }}</option>
          </select></label>
        <label class="kv-mezo"><span>Dátum *</span><input type="date" [(ngModel)]="szerk.datum"></label>
        <label class="kv-mezo"><span>{{ szepE(szerk.tipus) ? 'Utalt összeg *' : 'Érték (Ft) *' }}</span><input type="number" min="0" [(ngModel)]="szerk.ertek"></label>
        <label class="kv-mezo"><span>Megnevezés</span><input type="text" [(ngModel)]="szerk.megnevezes" maxlength="160"></label>
        <label class="kv-mezo"><span>Megjegyzés</span><input type="text" [(ngModel)]="szerk.megjegyzes" maxlength="255"></label>
        <div class="nk-kapcs" *ngIf="!szepE(szerk.tipus)"><label><input type="checkbox" [(ngModel)]="szerk.adomentes"> Adómentes (nincs közteher)</label></div>

        <p class="halvany jt-sugo" *ngIf="szepKeret(szerk) as k">
          {{ k.nev }}: keret <b>{{ ft(k.keret) }}</b> Ft, eddig utalva <b>{{ ft(k.utalt) }}</b> Ft{{ szerk.id ? ' (e tétellel együtt)' : '' }}.
          A keret feletti rész egyes meghatározott juttatásként adózik – a program mentéskor automatikusan szétosztja.
        </p>
        <p class="halvany jt-sugo" *ngIf="szerk.tipus === 'csekely_ajandek'">
          Csekély értékű ajándék: legfeljebb a minimálbér {{ szazalek(param.csekely_ajandek_hanyad) }}%-a ({{ ft(csekelyHatar) }} Ft),
          évente legfeljebb {{ param.csekely_ajandek_alkalom }} alkalommal. Egyes meghatározott juttatásként adózik.
          <b class="jt-neg" *ngIf="+szerk.ertek > csekelyHatar"> Az érték meghaladja a határt!</b>
        </p>
        <p class="halvany jt-sugo" *ngIf="szerk.tipus === 'egyeb_berenkivuli'">
          Béren kívüli juttatás: adóalap = az érték (SZJA + szocho). A juttatás kerete a program által nem figyelt – ellenőrizd a hatályos Szja tv. 71. §-t.
        </p>
        <div class="nk-lab"><button type="button" class="ov-gomb fo" (click)="ment()" [disabled]="mentes || (zarSor && !zarSor.irhato)"><ion-icon name="save-outline"></ion-icon>Mentés</button></div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<ion-modal #paramModal cssClass="ber-urlap-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Paraméterek – {{ aktiv.ev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="paramModal.dismiss()">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs">
      <app-ber-juttatas-param [ugyfelId]="aktiv.ugyfelId" [ev]="aktiv.ev" [csoportok]="['szep', 'ajandek', 'kozos']" (mentve)="paramMentve()"></app-ber-juttatas-param>
    </div>
  </ng-template>
</ion-modal>
